import type { AppBarProps } from '@mui/material'
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { experimentalStyled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import type { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'

import useAuth from 'src/hooks/useAuth'

import MenuIcon from '../../../icons/Menu'
import logo from '../../../icons/logo-dark.svg'

import { USER_PERMISSIONS } from 'src/common/constants/adminPermissions'
import { CustomTooltip } from '../generalComponents/StyledTooltip'
import PATHS from 'src/common/constants/paths'

interface DashboardNavbarProps extends AppBarProps {
    onSidebarMobileOpen?: () => void
    isMobile?: boolean
    isSidebarMobileOpen: boolean
    setIsSidebarMobileOpen: React.Dispatch<React.SetStateAction<boolean>>
}
const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
    ...(theme.palette.mode === 'light' && {
        backgroundColor: theme.palette.primary.main,
        boxShadow: 'none',
        color: theme.palette.primary.contrastText,
        paddingRight: 'unset !important',
    }),
    ...(theme.palette.mode === 'dark' && {
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        paddingRight: 'unset !important',
    }),
    zIndex: theme.zIndex.drawer - 1,
}))

const activeButton = (path: string, include: string[]) => {
    if (
        include.filter((elem) => {
            return path.includes(elem)
        }).length > 0
    ) {
        return { borderBottom: '2px solid #E4933D', backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' }
    } else return { bgcolor: 'transparent', color: 'primary' }
}

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
    const location = useLocation()
    // const navigate = useNavigate()

    const buttonNavBarStyle = {
        py: '1.21rem',
        width: { lg: '200px' },
        '&:hover': { backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' },
    }

    const { onSidebarMobileOpen, setIsSidebarMobileOpen, isMobile, ...other } = props
    // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    // const open = Boolean(anchorEl)

    // const [anchorElAnalytics, setAnchorElAnalytics] = useState<null | HTMLElement>(null)

    // const openAnalytics = Boolean(anchorElAnalytics)

    // const handleClick = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)

    // const handleClickAnalytics = (event: MouseEvent<HTMLButtonElement>) => setAnchorElAnalytics(event.currentTarget)

    // const handleClose = (path: string) => {
    //     if (path.length > 0) navigate(path)
    //     setAnchorEl(null)
    //     if (anchorElAnalytics) setAnchorElAnalytics(null)
    // }

    const {
        user: { permissions, payment_plans, username: customerEmail },
    } = useAuth()
    if (
        !isMobile &&
        [PATHS.DASHBOARD.SECONDARY_TOP_SELLING, PATHS.DASHBOARD.HISTORICAL_DATA].includes(location.pathname)
    ) {
        return null
    }

    return (
        <DashboardNavbarRoot {...other}>
            <Toolbar
                sx={{
                    height: '64px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    justifyContent: 'space-between',
                    backgroundImage: 'linear-gradient(to bottom, #0A1453, #000000)',
                    '@media (max-width: 900px)': {
                        flexDirection: 'row-reverse',
                    },
                }}
            >
                <IconButton
                    onClick={() => setIsSidebarMobileOpen(true)}
                    sx={{ display: { lg: 'none' }, color: '#FFFFFF' }}
                >
                    <MenuIcon fontSize="small" />
                </IconButton>
                {!isMobile && <></>}

                <Box
                    sx={{
                        color: 'primary',
                        // paddingRight: '24px',
                        // width: '16%',
                        // display: 'flex',
                        alignItems: 'center',
                        // gap: '20px',
                    }}
                >
                    {/* <img src={logo} alt="" /> */}
                    {/* <Typography
                        component={'span'}
                        sx={{
                            color: 'primary.main',
                            fontSize: '19px',
                            fontWeight: '500',
                        }}
                    >
                        Ticketmetric
                    </Typography> */}
                    <img
                        style={{
                            width: '10rem',
                            height: '2rem',
                            alignItems: 'center',
                            objectFit: 'cover',
                            marginLeft: '-8px',
                            marginRight: '8px',
                            imageRendering: 'crisp-edges',
                        }}
                        src={logo}
                        alt=""
                    />
                </Box>

                {!isMobile && (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '20px',
                                width: '100%',
                            }}
                        >
                            <Link to="/dashboard/upcoming">
                                <Button
                                    sx={{
                                        ...buttonNavBarStyle,
                                        ...activeButton(location.pathname, ['/dashboard/upcoming']),
                                    }}
                                >
                                    Upcoming Sales
                                </Button>
                            </Link>
                            <Link to="/dashboard/event_analytics">
                                <Button
                                    sx={{
                                        ...buttonNavBarStyle,
                                        ...activeButton(location.pathname, [
                                            '/event_analytics',
                                            '/secondary-favorites',
                                            '/primary-favorites',
                                        ]),
                                    }}
                                >
                                    Event Analytics
                                </Button>
                            </Link>
                            <Link to="/dashboard/metric">
                                <Button
                                    sx={{
                                        ...buttonNavBarStyle,
                                        ...activeButton(location.pathname, ['/metric']),
                                    }}
                                >
                                    Artist Metric
                                </Button>
                            </Link>
                            {/* <Link to="/dashboard/extension">
                        <Button
                            sx={{
                                ...buttonNavBarStyle,
                                ...activeButton(location.pathname, ['/extension']),
                            }}
                        >
                            Extension
                        </Button>
                    </Link>
                    <Link to="/dashboard/alerts">
                        <Button
                            sx={{
                                ...buttonNavBarStyle,
                                ...activeButton(location.pathname, ['/alerts']),
                            }}
                        >
                            Alerts
                        </Button>
                    </Link> */}
                            <Link to="/dashboard/academy">
                                <Button
                                    sx={{
                                        ...buttonNavBarStyle,
                                        ...activeButton(location.pathname, ['/dashboard/academy']),
                                    }}
                                >
                                    TMC Academy
                                </Button>
                            </Link>
                            {payment_plans[0].hasAccessToSalesReport ? (
                                <Link to="/dashboard/secondary-top-selling">
                                    <Button
                                        sx={{
                                            ...buttonNavBarStyle,
                                            ...activeButton(location.pathname, ['/dashboard/secondary-top-selling']),
                                        }}
                                    >
                                        SalesTIQ
                                    </Button>
                                </Link>
                            ) : (
                                <CustomTooltip
                                    title={
                                        <Typography>
                                            {`Please `}
                                            <Link
                                                to={`${process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_LINK}?prefilled_email=${customerEmail}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ color: 'white' }}
                                            >
                                                upgrade
                                            </Link>
                                            {` to the Advanced tier or above to access the data.`}
                                        </Typography>
                                    }
                                >
                                    <Button
                                        sx={{
                                            ...buttonNavBarStyle,
                                            ...activeButton(location.pathname, ['/dashboard/secondary-top-selling']),
                                            cursor: 'not-allowed',
                                            opacity: 0.5,
                                        }}
                                    >
                                        SalesTIQ
                                    </Button>
                                </CustomTooltip>
                            )}
                            {permissions?.includes(USER_PERMISSIONS.MANAGE_ADMIN_DASHBOARD) && (
                                <Link to="/dashboard/admin">
                                    <Button
                                        sx={{
                                            ...buttonNavBarStyle,
                                            ...activeButton(location.pathname, ['/dashboard/admin']),
                                        }}
                                    >
                                        Admin
                                    </Button>
                                </Link>
                            )}

                            {/* <Menu
                        id="basic-menu"
                        anchorEl={anchorElAnalytics}
                        open={openAnalytics}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}>
                        <MenuItem onClick={() => handleClose('/dashboard/primary-analytics/6553497d7071d1029bbba816')}>
                            Primary Analytics
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClose('/dashboard/secondary-analytics/6553497d7071d1029bbba816')}>
                            Secondary Analytics
                        </MenuItem>
                    </Menu> */}
                            {/* <Button
                        sx={{
                            ...buttonNavBarStyle,
                            ...activeButton(location.pathname, '/dashboard/primary-sellout'),
                        }}
                        onClick={handleClick}
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}>
                        Sellout
                    </Button> */}
                            {/* <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}>
                        <MenuItem onClick={() => handleClose('/dashboard/primary-sellout')}>Primary SellOut</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/primary-sellout-weekly')}>Primary Sellout
                            Weekly</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/primary-top-movers')}>Primary Top
                            Movers</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/secondary-top-movers')}>Secondary Top
                            Movers</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/percentage-leader')}>Percentage
                            Leader</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/top-price-surge')}>Top Price Surge</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/secondary-favorites')}>Primary
                            Favourites</MenuItem>
                        <MenuItem onClick={() => handleClose('/dashboard/secondary-favorites')}>Secondary
                            Favourites</MenuItem>
                    </Menu> */}
                            {/* <Link to="/dashboard/user">
                        <Button
                            sx={{
                                ...buttonNavBarStyle,
                                ...activeButton(location.pathname, '/user'),
                            }}>
                            User
                        </Button>
                    </Link> */}
                        </Box>
                    </>
                )}
            </Toolbar>
        </DashboardNavbarRoot>
    )
}
DashboardNavbar.propTypes = { onSidebarMobileOpen: PropTypes.func }
export default DashboardNavbar
